import { Component, cloneElement } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Collapse extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: props.isOpen
    }

    this.toggleCollapse = this.toggleCollapse.bind(this)
    this.bodyRef = (element) => {
      this.body = {
        height: element.clientHeight,
        ref: element
      }
    }
    this.titleRef = (element) => {
      this.title = {
        height: element.clientHeight,
        ref: element
      }
    }
    this.containerRef = (element) => {
      this.container = element
    }
  }

  componentDidMount () {
    this.updateCollpaseHeight(this.state.isOpen)
  }

  componentDidUpdate () {
    this.updateCollpaseHeight(this.state.isOpen)
  }

  updateCollpaseHeight (isOpen) {
    const containerHeight = isOpen ? 'auto' : `${this.title.height}px`

    this.container.style.height = containerHeight
  }

  toggleCollapse (event) {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }))
  }

  render () {
    const collapseClass = classNames(
      'react-collapse',
      this.props.className,
      {
        'is-open': this.state.isOpen
      }
    )

    const { title, content } = this.props

    const componentTitle = cloneElement(title, {
      isOpen: this.state.isOpen
    })

    return (
      <div
        className={collapseClass}
        style={{ overflow: 'hidden' }}
        ref={this.containerRef}>
        <div
          className="collapse-title"
          onClick={this.toggleCollapse}
          ref={this.titleRef}>
          { componentTitle }
        </div>

        <div
          className="collapse-body"
          ref={this.bodyRef}>
          { content }
        </div>
      </div>
    )
  }
}

Collapse.defaultProps = {
  isOpen: false,
  dynamicHeight: false
}

Collapse.propTypes = {
  isOpen: PropTypes.bool
}

export default Collapse
